// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shop_sidebar_sidebar__ONBHt {
    position: fixed;
    top: 0;
    left: -300px;
    width: 300px;
    height: 100vh;
    background-color: #ffffff;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
    transition: left 0.3s ease;
    z-index: 1000;
    overflow-y: auto;
}

.shop_sidebar_sidebar__ONBHt.shop_sidebar_active__R-gYN {
    left: 0;
}

.shop_sidebar_sidebarHeader__g\\+zX6 {
    display: flex;
    justify-content: flex-end;
    padding: 20px;
    border-bottom: 1px solid #f0f0f0;
}

.shop_sidebar_closeBtn__WHvIp {
    cursor: pointer;
    color: #666;
    transition: color 0.2s;
}

.shop_sidebar_closeBtn__WHvIp:hover {
    color: #000;
}

.shop_sidebar_userProfile__3leCE {
    display: flex;
    align-items: center;
    padding: 10px 15px;
    background-color: #f7f7f7;
    cursor: pointer;
    transition: background-color 0.2s;
}

.shop_sidebar_userProfile__3leCE:hover {
    background-color: #eaeaea;
}

.shop_sidebar_avatar__5vY-M {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: var(--global-main-color);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: bold;
    margin-right: 15px;
}

.shop_sidebar_userInfo__uPXHf {
    /* flex: 1; */
    padding-top: 20px;
    text-align: left;
}

.shop_sidebar_userInfo__uPXHf h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
}

.shop_sidebar_points__5h6CH {
    /* margin: 5px 0 0; */
    color: var(--global-main-color);
    font-size: 14px;
    font-weight: 500;
}

.shop_sidebar_menuItems__nxyqa {
    padding: 10px 0;
}

.shop_sidebar_menuItem__y8fiu {
    display: flex;
    align-items: center;
    padding: 15px 20px;
    cursor: pointer;
    transition: background-color 0.2s;
}

.shop_sidebar_menuItem__y8fiu:hover {
    background-color: rgba(0, 159, 127, 0.1);
}

.shop_sidebar_icon__PFCW- {
    width: 20px;
    margin-right: 15px;
    color: #555;
}

.shop_sidebar_menuItem__y8fiu:hover .shop_sidebar_icon__PFCW- {
    color: var(--global-main-color);
}

.shop_sidebar_sidebarFooter__7vuz5 {
    padding: 20px;
    border-top: 1px solid #f0f0f0;
    margin-top: auto;
}

.shop_sidebar_support__0Hapc {
    display: flex;
    align-items: center;
    color: #666;
    font-size: 14px;
}

.shop_sidebar_support__0Hapc .shop_sidebar_icon__PFCW- {
    color: var(--global-main-color);
}

.shop_sidebar_pendingOrderAlert__zQGd6 {
    margin: 10px 15px;
    padding: 10px;
    background-color: #fff8e1;
    border-left: 4px solid #ffc107;
    border-radius: 4px;
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: background-color 0.2s;
    text-align: left;
}

.shop_sidebar_pendingOrderAlert__zQGd6:hover {
    background-color: #fff3cd;
}

.shop_sidebar_pendingOrderIcon__u9FOk {
    color: #ffc107;
    font-size: 24px;
    margin-right: 15px;
}

.shop_sidebar_pendingOrderInfo__D-BqU {
    flex: 1 1;
}

.shop_sidebar_pendingOrderInfo__D-BqU h4 {
    margin: 0 0 5px 0;
    font-size: 16px;
    font-weight: 600;
    color: #333;
}

.shop_sidebar_pendingOrderInfo__D-BqU p {
    margin: 2px 0;
    font-size: 13px;
    color: #666;
}

.shop_sidebar_notificationBadge__Ifee- {
    background-color: #ff5252;
    color: white;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: bold;
    margin-left: auto;
}`, "",{"version":3,"sources":["webpack://./src/shop/components/sidebar/shop_sidebar.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,uCAAuC;IACvC,0BAA0B;IAC1B,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0CAA0C;IAC1C,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB","sourcesContent":[".sidebar {\n    position: fixed;\n    top: 0;\n    left: -300px;\n    width: 300px;\n    height: 100vh;\n    background-color: #ffffff;\n    box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);\n    transition: left 0.3s ease;\n    z-index: 1000;\n    overflow-y: auto;\n}\n\n.sidebar.active {\n    left: 0;\n}\n\n.sidebarHeader {\n    display: flex;\n    justify-content: flex-end;\n    padding: 20px;\n    border-bottom: 1px solid #f0f0f0;\n}\n\n.closeBtn {\n    cursor: pointer;\n    color: #666;\n    transition: color 0.2s;\n}\n\n.closeBtn:hover {\n    color: #000;\n}\n\n.userProfile {\n    display: flex;\n    align-items: center;\n    padding: 10px 15px;\n    background-color: #f7f7f7;\n    cursor: pointer;\n    transition: background-color 0.2s;\n}\n\n.userProfile:hover {\n    background-color: #eaeaea;\n}\n\n.avatar {\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    background-color: var(--global-main-color);\n    color: white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 20px;\n    font-weight: bold;\n    margin-right: 15px;\n}\n\n.userInfo {\n    /* flex: 1; */\n    padding-top: 20px;\n    text-align: left;\n}\n\n.userInfo h3 {\n    margin: 0;\n    font-size: 16px;\n    font-weight: 600;\n}\n\n.points {\n    /* margin: 5px 0 0; */\n    color: var(--global-main-color);\n    font-size: 14px;\n    font-weight: 500;\n}\n\n.menuItems {\n    padding: 10px 0;\n}\n\n.menuItem {\n    display: flex;\n    align-items: center;\n    padding: 15px 20px;\n    cursor: pointer;\n    transition: background-color 0.2s;\n}\n\n.menuItem:hover {\n    background-color: rgba(0, 159, 127, 0.1);\n}\n\n.icon {\n    width: 20px;\n    margin-right: 15px;\n    color: #555;\n}\n\n.menuItem:hover .icon {\n    color: var(--global-main-color);\n}\n\n.sidebarFooter {\n    padding: 20px;\n    border-top: 1px solid #f0f0f0;\n    margin-top: auto;\n}\n\n.support {\n    display: flex;\n    align-items: center;\n    color: #666;\n    font-size: 14px;\n}\n\n.support .icon {\n    color: var(--global-main-color);\n}\n\n.pendingOrderAlert {\n    margin: 10px 15px;\n    padding: 10px;\n    background-color: #fff8e1;\n    border-left: 4px solid #ffc107;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    transition: background-color 0.2s;\n    text-align: left;\n}\n\n.pendingOrderAlert:hover {\n    background-color: #fff3cd;\n}\n\n.pendingOrderIcon {\n    color: #ffc107;\n    font-size: 24px;\n    margin-right: 15px;\n}\n\n.pendingOrderInfo {\n    flex: 1;\n}\n\n.pendingOrderInfo h4 {\n    margin: 0 0 5px 0;\n    font-size: 16px;\n    font-weight: 600;\n    color: #333;\n}\n\n.pendingOrderInfo p {\n    margin: 2px 0;\n    font-size: 13px;\n    color: #666;\n}\n\n.notificationBadge {\n    background-color: #ff5252;\n    color: white;\n    border-radius: 50%;\n    width: 20px;\n    height: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 12px;\n    font-weight: bold;\n    margin-left: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": `shop_sidebar_sidebar__ONBHt`,
	"active": `shop_sidebar_active__R-gYN`,
	"sidebarHeader": `shop_sidebar_sidebarHeader__g+zX6`,
	"closeBtn": `shop_sidebar_closeBtn__WHvIp`,
	"userProfile": `shop_sidebar_userProfile__3leCE`,
	"avatar": `shop_sidebar_avatar__5vY-M`,
	"userInfo": `shop_sidebar_userInfo__uPXHf`,
	"points": `shop_sidebar_points__5h6CH`,
	"menuItems": `shop_sidebar_menuItems__nxyqa`,
	"menuItem": `shop_sidebar_menuItem__y8fiu`,
	"icon": `shop_sidebar_icon__PFCW-`,
	"sidebarFooter": `shop_sidebar_sidebarFooter__7vuz5`,
	"support": `shop_sidebar_support__0Hapc`,
	"pendingOrderAlert": `shop_sidebar_pendingOrderAlert__zQGd6`,
	"pendingOrderIcon": `shop_sidebar_pendingOrderIcon__u9FOk`,
	"pendingOrderInfo": `shop_sidebar_pendingOrderInfo__D-BqU`,
	"notificationBadge": `shop_sidebar_notificationBadge__Ifee-`
};
export default ___CSS_LOADER_EXPORT___;
